import { useNuxtApp } from '#app'

interface MixpanelComposable {
  track: (event: string, properties?: Record<string, any>) => void
  identify: (userId: string) => void
  setUserProperties: (properties: Record<string, any>) => void
}

export default function useMixpanel (): MixpanelComposable {
  const nuxtApp = useNuxtApp()
  const $mixpanel = (nuxtApp as any).$mixpanel

  const track = (event: string, properties?: Record<string, any>): void => {
    if (import.meta.client && $mixpanel) {
      $mixpanel.track(event, properties)
    }
  }

  const identify = (userId: string): void => {
    if (import.meta.client && $mixpanel) {
      $mixpanel.identify(userId)
    }
  }

  const setUserProperties = (properties: Record<string, any>): void => {
    if (import.meta.client && $mixpanel) {
      $mixpanel.set(properties)
    }
  }

  return {
    track,
    identify,
    setUserProperties
  }
}
